import { render } from "./UpdateCoupon.vue?vue&type=template&id=46361a6e&scoped=true"
import script from "./UpdateCoupon.vue?vue&type=script&lang=js"
export * from "./UpdateCoupon.vue?vue&type=script&lang=js"

import "./UpdateCoupon.vue?vue&type=style&index=0&id=46361a6e&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46361a6e"]])

export default __exports__